import * as React from 'react';

function SvgDismissDialogIcon(props) {
  return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path fill="#fff" d="M16 14.049 1.697 0 .182 1.488l14.304 14.048z" />
    <path fill="#fff" d="M14.303.464 0 14.513 1.514 16 15.818 1.951z" />
  </svg>)
}
export default SvgDismissDialogIcon;
